export default {
	PUSH_NOTIFICATION: 'PUSH_NOTIFICATION',
	TYPE_INFO: 'info',
	TYPE_WARNING: 'warning',
	TYPE_ERROR: 'error',
};
